<template>
  <div class="screenpic">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作流</el-breadcrumb-item>
          <el-breadcrumb-item>活动投稿</el-breadcrumb-item>
          <el-breadcrumb-item>筛选</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div @click="goTable"
           class="refresh">
        <img width="18px"
             height="15px"
             src="@/assets/sreenpic/goback.png"
             alt />
        <p>返回列表</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <!-- <el-popover placement="right"
                    trigger="manual"
                    :content="desc || '暂无'"
                    v-model="visible"> -->
        <el-tooltip class="item" effect="light" :content="desc || '暂无备注'" placement="right">
          <h4 style="cursor: pointer;">投稿图片筛选 · {{$route.query.name}}</h4>
        </el-tooltip>
        
        <!-- </el-popover> -->
        <!-- <el-button @click="descdialogVisible = true">查看备注</el-button> -->
        <div class="steps">
          <div class="stepsbj">
            <img v-if="activeSteps >= 0"
                 src="@/assets/sreenpic/yellow.png"
                 alt="">
            <p>1</p>
          </div>
          <div class="text"
               :style="{'color':activeSteps >= 0 ? 'rgba(254,142,36,1)':''}">初选</div>
          <div class="xian"
               :style="{'borderBottom':activeSteps > 0 ? '2px dashed rgba(254,142,36,1)':'2px dashed #185ED3'}"></div>
          <div class="stepsbj">
            <img v-if="activeSteps >= 1"
                 src="@/assets/sreenpic/yellow.png"
                 alt="">
            <img v-if="activeSteps < 1"
                 src="@/assets/sreenpic/blue.png"
                 alt="">
            <p>2</p>
          </div>
          <div class="text"
               :style="{'color':activeSteps >= 1 ? 'rgba(254,142,36,1)':'#185ED3'}">复审</div>
          <div class="xian"
               :style="{'borderBottom':activeSteps > 1 ? '2px dashed rgba(254,142,36,1)':'2px dashed #185ED3'}"></div>
          <div class="stepsbj">
            <img v-if="activeSteps >= 2"
                 src="@/assets/sreenpic/yellow.png"
                 alt="">
            <img v-if="activeSteps < 2"
                 src="@/assets/sreenpic/blue.png"
                 alt="">
            <p>3</p>
          </div>
          <div class="text"
               :style="{'color':activeSteps >= 2 ? 'rgba(254,142,36,1)':'#185ED3'}">筛选结果</div>
        </div>
      </div>

      <firstchoose v-if="activeSteps == 0"></firstchoose>
      <review v-if="activeSteps == 1"
              @savePic="savePic"></review>
      <result v-if="activeSteps == 2"></result>
    </div>
    <el-dialog :visible.sync="descdialogVisible"
               width="30%"
               class="descdialogVisible">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>备注</div>
      </div>
      <div>{{desc || '暂无'}}</div>
      <!-- <span slot="footer"
            class="dialog-footer">
        <el-button @click="descdialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="descdialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
    <!-- <picdescdialog :dialogVisible="descdialogVisible"></picdescdialog> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getDate, formatConversion } from "@/plugins/getdate";
import { picdescdialog, firstchoose, result, review } from "@/components/index";

import {
  checkPictures,
  setTaskStatus,
  getTask,
  listWorkflow
} from "@/api/workflow";


export default {
  components: {
    picdescdialog, firstchoose, result, review
  },
  data () {
    return {
      descdialogVisible: false,
      descdialog: false,
      picDescribe: '',
      activeSteps: 0,
      // stepimgsrc:require('@/assets/screenpic/yellow.png')
      visible: true,
      desc: ''
    };
  },
  methods: {
    goTable () {
      // this.$router.go(0)
    },
    openDialog () {
      this.descdialog = false
    },
    opendesc () {
      this.descdialog = true
    },
    savePic (val) {
      let picId = []
      for (let i = 0; i < val.length; i++) {
        picId.push(val[i].pictureId)
      }
      let data = {
        pictureIds: picId.join(','),
        pictureArticleFilterTaskId: val[0].pictureArticleFilterTaskId,
      }
      this.checkPicturesAsync(data)
    },

    //设置任务状态
    async setTaskStatusAsync (val) {
      let { status, data, message } = await setTaskStatus(
        val
      );
    },

    //获取备注信息
    async getTaskAsync () {
      let { status, data, message } = await getTask(
        this.$route.query.pictureArticleFilterTaskId
      );
      if (status) {
        this.desc = data.desc
      }
    },
    //获取送审备注信息
    async listWorkflowAsync (val) {
      let { status, data, message } = await listWorkflow(
        val
      );
      if (status) {
        this.desc = data[0].message
      }
    },


    //获取选入图片列表
    async checkPicturesAsync (val) {
      let { status, data, message } = await checkPictures(val);
      if (status) {
        this.$message.success('保存成功！')
        this.$router.push("/workflow/listTask");
        // this.setTaskStatusAsync(data)
      } else {
        this.$message.error(message)
      }
    }
  },
  created () {
    this.activeSteps = this.$route.query.activeSteps
    if (this.activeSteps == 0) {
      this.getTaskAsync()
    } else if (this.activeSteps == 1) {
      let val = {
        pictureActivityArticleId: 0,
        pictureId: 0,
        actionName: '送审',
        pictureActivityId: this.$route.query.id,
        pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId
      }
      this.listWorkflowAsync(val)
    } else if (this.activeSteps == 2) {
      this.visible = false
    }
  },
  beforeDestroy () { },
  mounted () { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./screenpic.scss";
@import "@/constants/elHeader.scss";
// .descdialogVisible /deep/ .el-dialog__body {
//   min-height: 200px;
// }
</style>
